const Disqualification = Object.freeze({
    PREGNANT: "pregnant",
    RECENT_HEART_ATTACK: "recent heart attack",
    COPD: "COPD",
    ASTHMA: "asthma",
    ARRHYTHMIA: "arrhythmia",
    TACHYCARDIA: "tachycardia",
    CHRONIC_KIDNEY_DISEASE: "chronic kidney disease",
    RECENT_IODINE_TREATMENT: "recent iodine treatment",
    CONTRAST_DYE_ALLERGY: "contrast dye allergy",
    HOLD_BREATH: "hold breath",
    YOUNG_NO_RISK_FACTORS: "young - no risk factors",
    YOUNG_WITH_RISK_FACTORS: "young - with risk factors",
    HEART_BLOCK: 'heart block',
    HEART_FAILURE: 'heart failure',
    NO_LIPID_TEST: 'no lipid test',
    END_STAGE_KIDNEY_DISEASE: 'end stage kidney disease',
    END_STAGE_LIVER_DISEASE: 'end stage liver disease',
    CIRROHOSIS: 'cirrohsis',
    BREASTFEEDING: 'breastfeeding',
    STATIN_ADVERSE_REACTION: 'statin adverse reaction',
    UNDER_18: 'under 18',
    EZETIMIBE_ADVERSE_REACTION: 'ezetimibe adverse reaction',
    METFORMIN_ADVERSE_REACTION: 'metformin adverse reaction',
    HEAVY_ALCOHOL_CONSUMPTION: 'heavy alcohol consumption',
    LOW_GLUCOSE: 'low glucose',
    LOW_HBA1C: 'low hba1c',
})

export default Disqualification